import EmailTemplate from '../../../FormComponents/EmailTemplate';
import Spinner from '../../../Fundamentals/Spinner/Spinner';
import type { ChangeEmail, ChangeEmailForm } from '../../../Modals/ConfirmSubscriptionChange/ConfirmSubscriptionChange.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UntypedEmailTemplate = EmailTemplate as any;

interface Props {
    form: ChangeEmailForm | undefined;
    onChange: (field: keyof ChangeEmail, value: string) => void;
}

const ConfirmSubscriptionChangeEmailTemplate = ({ form, onChange }: Props) => {
    if (!form?.data) return <Spinner />;

    return <UntypedEmailTemplate data={form.data} onChange={onChange} />;
};

export default ConfirmSubscriptionChangeEmailTemplate;
